import dayjs from 'dayjs'

const LONG_DATE_FORMAT = 'MMM D, YYYY h:mm A'

export const formatToLongDatetime = (dt) => {
    return dayjs(dt).format(LONG_DATE_FORMAT)
}
